export function isHttpUrl(value) {
  try {
    const url = new URL(String(value || '').trim())
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch {
    return false
  }
}

export function parseUnitPriceInput(value) {
  const text = String(value ?? '').trim().replace(/,/g, '')
  if (!text) return null
  if (!/^\d+(\.\d+)?$/.test(text)) return Number.NaN
  return Number(text)
}

export const QUOTATION_MAX_BYTES = 10 * 1024 * 1024

export function formatFileSize(bytes) {
  const value = Number(bytes)
  if (!Number.isFinite(value) || value < 0) return '-'
  if (value < 1024) return `${value} B`
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`
  return `${(value / (1024 * 1024)).toFixed(1)} MB`
}

export function quotationFileError(file) {
  if (!file) return ''
  const extension = String(file.name || '').split('.').pop().toLowerCase()
  if (!['pdf', 'jpg', 'jpeg', 'png'].includes(extension)) return '견적서는 PDF, JPG, PNG만 첨부할 수 있습니다.'
  if (file.size > QUOTATION_MAX_BYTES) return '견적서는 10MB 이하여야 합니다.'
  return ''
}

export function validatePurchaseInput({ purchaseUrl, unitPrice, file, keepQuotation = false }) {
  const url = String(purchaseUrl || '').trim()
  if (url && !isHttpUrl(url)) return '구매처 링크는 http 또는 https URL이어야 합니다.'
  if (!url && !file && !keepQuotation) return '구매처 링크 또는 견적서 중 하나는 필요합니다.'
  const fileError = quotationFileError(file)
  if (fileError) return fileError
  const price = parseUnitPriceInput(unitPrice)
  if (price == null) return '예상 단가를 입력해 주세요.'
  if (!Number.isFinite(price) || price < 0) return '예상 단가는 0 이상의 숫자여야 합니다.'
  return ''
}

export function formatUnitPrice(value) {
  if (value == null || value === '') return '-'
  const number = Number(value)
  if (!Number.isFinite(number)) return '-'
  return `${number.toLocaleString('ko-KR')}원`
}

export function formatExpectedTotal(quantity, unitPrice) {
  if (unitPrice == null || unitPrice === '' || quantity == null || quantity === '') return '-'
  const qty = Number(quantity)
  const price = Number(unitPrice)
  if (!Number.isFinite(qty) || !Number.isFinite(price)) return '-'
  return `${(qty * price).toLocaleString('ko-KR')}원`
}

export function canEditPartRequest(user, request) {
  if (!user || !request) return false
  if (user.role === 'admin' || user.role === 'manager') return true
  if (String(user.id || '') !== String(request.requesterId || '')) return false
  return request.status !== 'COMPLETED'
}
